/**
 * @generated SignedSource<<5ecc73b08a8a43e039dafc196e6bbf73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorProjectContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectRelatedSearchesContainer_viewer">;
  readonly " $fragmentType": "InteriorProjectContent_viewer";
};
export type InteriorProjectContent_viewer$key = {
  readonly " $data"?: InteriorProjectContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorProjectContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorProjectContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectRelatedSearchesContainer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8c5e9fc1f6f046ba8a3b95a7cf312cc9";

export default node;
